import { ExitFullScreenButton } from "@Src/constants";
import {
	Box,
	Button,
	Card,
	CardContent,
	CardHeader,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

export const ThanksResponsesPages = () => {
	const [isFullscreen, setIsFullscreen] = useState(
		!!document.fullscreenElement,
	);

	useEffect(() => {
		const handleFullscreenChange = () => {
			setIsFullscreen(!!document.fullscreenElement);
		};

		document.addEventListener("fullscreenchange", handleFullscreenChange);

		return () => {
			document.removeEventListener("fullscreenchange", handleFullscreenChange);
		};
	}, []);

	const handleExitFullscreen = async () => {
		if (document.fullscreenElement) {
			await document.exitFullscreen();
		}
	};

	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			minHeight="80vh"
			bgcolor="background.default"
			px={2}
		>
			<Card sx={{ maxWidth: 500, textAlign: "center", p: 2 }}>
				<CardHeader
					title="🎉 Thank you!"
					titleTypographyProps={{ variant: "h4", align: "center" }}
				/>
				<CardContent>
					<Typography variant="body1" gutterBottom>
						Thank you for your responses!
					</Typography>
					{isFullscreen && (
						<Button
							variant="contained"
							color="primary"
							onClick={handleExitFullscreen}
						>
							{ExitFullScreenButton}
						</Button>
					)}
				</CardContent>
			</Card>
		</Box>
	);
};
